import config from '../../common/config';
import { getPolygonColor, calculatePolygonZIndex, formatDayLabel } from '../../common/polygonUtils';

const state = {
  center: { lat: 45.508, lng: -73.587 },
  markers: [],
  placesToSet: [],
  currentPlace: null,
  appPointsToUpdateIfMapLowdAfterPoints: [],
  appMap: null,
  mapWereloded: false,
  appMaps: [],
  appMapsMarkers: [],
  polygons: [],

};
const getters = {
  center: state => state.center,
  markers: state => state.markers,
  placesToSet: state => state.placesToSet,
  currentPlace: state => state.currentPlace,
  appPointsToUpdateIfMapLowdAfterPoints: state => state.appPointsToUpdateIfMapLowdAfterPoints,
  appMap: state => state.appMap,
  mapWereloded: state => state.mapWereloded,
  appMaps: state => state.appMaps,
  appMapsMarkers: state => state.appMapsMarkers,
  appMapFromMaps: state => ( index ) => state.appMaps[ index ],
  polygons: state => state.polygons,

};
const actions = {
  addMap({ getters, commit, dispatch }, kwargs ){
    // ***** this part of code is creating new map (only after getting the google scripts fro gmap-map)
    // ***** and lowding it to part at the code with the id map_canvas
    // it is nesesery if we whant to lowd more than one map!!!!!!!!!!!!
    // const elementId = "map_canvas"
    // const appMaps = getters.appMaps;
    // state.appMaps.length
    // console.log(google.maps.MapTypeId.ROADMAP )
    // var myOptions = {
    //   zoom: 8,
    //   center: {lat:0, lng:0},
    //   mapTypeId: google.maps.MapTypeId.ROADMAP
    // }
    // var map = new google.maps.Map(document.getElementById( kwargs.elementId ), myOptions);

    const map = getters.appMap;
    var i;
    var markers = [];
    var pointsToUpdateIfTheMapLodedAfterThePoints = [];
    for( i=0; i < kwargs.points.length; i++ ){
      const reversedOrdering = kwargs.points.length - 1 - i;
      const src = kwargs.points[reversedOrdering];
      const point = { latPoint: src.lat, lngPoint: src.lng };
      if( src.numberedMarker )
        point.numberedMarker = src.numberedMarker;
      else if( src.iconUrl )
        point.iconUrl = src.iconUrl;
      dispatch( 'addMarkerByLatAndLng', {
                  map:map,
                  rideMarkers: markers,
                  point:point
                });
      pointsToUpdateIfTheMapLodedAfterThePoints.push(point)
    }
    commit( 'setAppPointsToUpdateIfMapLowdAfterPoints', pointsToUpdateIfTheMapLodedAfterThePoints );
    commit( 'setAddAppMaps', { map: map, markers: markers } );
    dispatch( 'fitBoundesToMarkers', {
      appMap:map,
      markers: markers,
    });

  },
  thisMapWereCreated:({getters, dispatch}) =>{
    const appMap = getters.appMap;
    const points = getters.appPointsToUpdateIfMapLowdAfterPoints;
    var i;
    var markers = [];
    for( i=0; i < points.length; i++ ){
      dispatch( 'addMarkerByLatAndLng', {
        map:appMap,
        rideMarkers: markers,
        point:points[i]
      });
    }
    dispatch( 'fitBoundesToMarkers', {
      appMap:appMap,
      markers: markers,
    });
  },
  addMarkerByLatAndLngToGlobalMap: ({dispatch, getters }, point) => {
    const appMap = getters.appMap;
    // const appMap = getters.appMapFromMaps(0).map;
    const rideMarkers = getters.markers;
    dispatch( 'addMarkerByLatAndLng', {
      map:appMap,
      rideMarkers: rideMarkers,
      point:point
     });
    },

  removeAllMarkersFromGlobalMAp: ({dispatch, getters, commit }) =>{
    const markers = getters.markers;
    commit( "clearAppPointsToUpdateIfMapLowdAfterPoints" )
    dispatch( 'removeAllMarkers', markers );
  },

  fitBoundesToMarkersAtGlobalMap: ({dispatch, getters }, zoomLevel=null) => {
    const appMap = getters.appMap;
    const markers = getters.markers;
    dispatch( 'fitBoundesToMarkers', {
      appMap:appMap,
      markers: markers,
      zoomLevel: zoomLevel
     });

  },
  // addMarker: ({state, commit }) => {
  //   if (state.currentPlace) {
  //     const marker = {
  //       lat: state.currentPlace.geometry.location.lat(),
  //       lng: state.currentPlace.geometry.location.lng()
  //     };
  //     commit( 'addMarker', marker );
  //     commit( 'addPlace', state.currentPlace );
  //     commit( 'setCenter', marker);
  //     commit( 'setCurrentPlace', null);
  //   }
  // },
  async geolocate({commit}) {
    const position = await navigator.geolocation.getCurrentPosition()
    const center = {
      lat: position.coords.latitude,
      lng: position.coords.longitude
    };
    commit('center',center);
  },
  setOneMarker({ dispatch }, point ) {
    dispatch('removeAllMarkersFromGlobalMAp');
    dispatch( 'addMarkerByLatAndLngToGlobalMap', point );
    dispatch( 'fitBoundesToMarkersAtGlobalMap', point.zoomLevel);
  },
  async updatemarkerByColersAndLetter( __,points ){
    var i;
    const baseCircleUrl = config.config.BLUE_MAP_POINT_CIRCLE_BASE;
    for( i = 0; i < points.length; i++ ){
      points[i].numberedMarker = { baseCircleUrl, number: i + 1 };
    }
    return points;
  },
  async updatemarkerByColers( __,points ){
    var i;
    const baseCircleUrl = config.config.BLUE_MAP_POINT_CIRCLE_BASE;
    for( i = 0; i < points.length; i++ ){
      points[i].numberedMarker = { baseCircleUrl, number: i + 1 };
    }
    return points;
  },
  addPolygonToGlobalMap: ({getters, commit}, { polygonPath, dayNumber = null, days = null, zIndex = null }) => {
    const appMap = getters.appMap;
    if (!appMap || !polygonPath || polygonPath.length < 3) {
      return;
    }
    
    // Convert coordinates to google.maps.LatLng objects
    const path = polygonPath.map(point => 
      new google.maps.LatLng(parseFloat(point.lat), parseFloat(point.lng))
    );
    
    // Generate color and z-index based on day number
    const baseDayNumber = dayNumber !== null ? dayNumber : (days && days.length > 0 ? days[0] : 1);
    const polygonColor = getPolygonColor(baseDayNumber);
    const polygonZIndex = zIndex !== null ? calculatePolygonZIndex(zIndex) : calculatePolygonZIndex(baseDayNumber);
    
    // Create polygon
    const polygon = new google.maps.Polygon({
      paths: path,
      strokeColor: polygonColor,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: polygonColor,
      fillOpacity: 0.25,
      map: appMap,
      zIndex: polygonZIndex
    });
    
    // Add label if day number or days are provided
    if (dayNumber !== null || (days && days.length > 0)) {
      // Create custom overlay for label that moves with polygon
      class PolygonLabelOverlay extends google.maps.OverlayView {
        constructor(bounds, text, color, labelZIndex) {
          super();
          this.bounds = bounds;
          this.text = text;
          this.color = color;
          this.labelZIndex = labelZIndex;
          this.div = null;
        }
        
        onAdd() {
          const div = document.createElement('div');
          div.style.position = 'absolute';
          div.style.padding = '4px 8px';
          div.style.backgroundColor = this.color;
          div.style.color = '#ffffff';
          div.style.fontSize = '14px';
          div.style.fontWeight = 'bold';
          div.style.border = '2px solid #ffffff';
          div.style.borderRadius = '3px';
          div.style.boxShadow = '0 2px 4px rgba(0,0,0,0.3)';
          div.style.whiteSpace = 'nowrap';
          div.style.zIndex = this.labelZIndex.toString();
          div.textContent = this.text;
          
          this.div = div;
          const panes = this.getPanes();
          panes.overlayMouseTarget.appendChild(div);
        }
        
        draw() {
          const overlayProjection = this.getProjection();
          const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast());
          const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest());
          
          // Position at top-left corner of polygon
          this.div.style.left = sw.x + 'px';
          this.div.style.top = (ne.y - this.div.offsetHeight) + 'px';
        }
        
        onRemove() {
          if (this.div && this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
          }
        }
      }
      
      // Calculate bounds for label positioning
      const bounds = new google.maps.LatLngBounds();
      path.forEach(latLng => bounds.extend(latLng));
      
      // Create label text using utility function
      const labelText = formatDayLabel(dayNumber, days);
      
      // Calculate label z-index (same as polygon, but higher to appear above polygon)
      const labelZIndex = polygonZIndex + 100;
      
      // Create and add label overlay
      const labelOverlay = new PolygonLabelOverlay(bounds, labelText, polygonColor, labelZIndex);
      labelOverlay.setMap(appMap);
      
      // Store label with polygon
      polygon.label = labelOverlay;
    }
    
    commit('addPolygon', polygon);
  },
  removeAllPolygonsFromGlobalMap: ({getters, commit}) => {
    const polygons = getters.polygons;
    polygons.forEach(polygon => {
      polygon.setMap(null);
      // Remove label if it exists
      if (polygon.label) {
        if (polygon.label.setMap) {
          polygon.label.setMap(null);
        } else if (polygon.label.remove) {
          polygon.label.remove();
        }
      }
    });
    commit('clearPolygons');
  },
  fitBoundsToPolygons: ({getters}) => {
    const appMap = getters.appMap;
    const polygons = getters.polygons;
    
    if (!appMap || !polygons || polygons.length === 0) {
      return;
    }
    
    // Create bounds that include all polygons
    const bounds = new google.maps.LatLngBounds();
    
    polygons.forEach(polygon => {
      if (polygon && polygon.getPaths) {
        const paths = polygon.getPaths();
        paths.forEach(path => {
          path.forEach(latLng => {
            bounds.extend(latLng);
          });
        });
      }
    });
    
    // Fit map to bounds with padding
    if (polygons.length > 0) {
      appMap.fitBounds(bounds, {
        top: 50,
        right: 50,
        bottom: 50,
        left: 50
      });
    }
  },
}
const mutations = {
  setCurrentPlace( state, place ) {
    state.currentPlace = place;
  },
  setAppMap( state, appMap ) {
    state.appMap = appMap;
    state.mapWereloded = true
    this.dispatch( 'thisMapWereCreated' );
  },
  setAddAppMaps( state, appMap ) {
    state.appMaps.push( { appMap:appMap.map, markers:appMap.markers} );
  },
  setClearAppMaps( state ) {
    while ( state.appMaps.length > 0) {
      state.appMaps.pop();
    }
    // we should consider to remove this one
    while ( state.appMapsMarkers.length > 0) {
      state.appMapsMarkers.pop();
    }
  },
  // we should consider to remove this one
  setAddAppMapsMarkers( state, marker ) {
    state.appMapsMarkers.push( marker );
  },
  addMarker( state, marker ) {
    state.markers.push( marker );
  },
  addPlace( state, place ) {
    state.placesToSet.push( { place } );
  },
  setCenter( state, center ) {
    state.center =  center;
  },
  setAppPointsToUpdateIfMapLowdAfterPoints( state, points ) {
    state.appPointsToUpdateIfMapLowdAfterPoints = points;
  },
  clearAppPointsToUpdateIfMapLowdAfterPoints( state ) {
    state.appPointsToUpdateIfMapLowdAfterPoints = [];
  },
  addPolygon( state, polygon ) {
    state.polygons.push( polygon );
  },
  clearPolygons( state ) {
    state.polygons = [];
  },

};

export default {
  state,
  getters,
  actions,
  mutations
};
